import React from 'react';
import { Card, Badge, Image, ListGroup, Modal, Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ConfettiExplosion from 'react-confetti-explosion';

function ModalCheckout({ show, onHide, checkoutSummary, isLoading, showConfetti }) {
    const { t } = useTranslation();

    return (
        <Modal show={show} onHide={onHide} centered size="xl">
            {showConfetti && (
                <ConfettiExplosion
                    duration={8000}
                    particleCount={250}
                    colors={['#ff0000', '#00ff00', '#0000ff', '#ffff00', '#ff00ff', '#00ffff']}
                    width={window.innerWidth}
                />
            )}
            <Modal.Body className="p-10">
                {isLoading ? (
                    <div className="text-center mb-3">
                        <Spinner animation="border" />
                        <p className="mt-2">{t('Your order is being processing')}...</p>
                    </div>
                ) : (
                    <>
                    <div className="text-center mb-3">
                        <h3>❤️ {t('Thank you for your order!')}</h3>
                        <p>{t('We have received your order. You will receive a summary by mail shortly.')}</p>
                        <Link to="/dashboard/overview" className="btn btn-secondary mt-4" onClick={onHide} disabled={isLoading}>
                            {isLoading ? (
                                <>
                                    <Spinner animation="border" size="sm" className="me-2" />
                                    {t('Back to Dashboard')}
                                </>
                            ) : (
                                t('Back to Dashboard')
                            )}
                        </Link>
                    </div>
                    
                    </>
                )}
            </Modal.Body>
        </Modal>
    );
}

export default ModalCheckout;